"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class BankTransactionFile extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "BankTransactionFile";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/bank-transaction-files"
    );
  }

  getApiPathForCreate() {}

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/bank-transaction-files/" +
      this.id
    );
  }

  getAdminPath() {
    return "/bank-transaction-files/" + this.id;
  }

  get searchResultTitle() {
    return null;
  }

  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default BankTransactionFile;
